import initAudioComponent from "../initAudioComponent.js";

document.addEventListener("DOMContentLoaded", () => {
  initAudioComponent();
});
